import { Property } from '../../constants/telemetry';
import { ClientError, FailureOperation } from '../../models/common';
import { trackException, trackTrace } from '../telemetry/channel';

/**
 * parseJson
 */
export const parseJson = <T>(jsonString: string): T => {
    try {
        return JSON.parse(jsonString) as T;
    } catch (err) {
        const clientError = new ClientError(err, FailureOperation.DataPlaneErrorParsing);
        trackException(clientError);

        // Regex to check if the string starts with an HTML element
        // Matches <!doctype>, <html>, <head>, or <body> at the start of the string
        const htmlElementRegex = /^\s*<(!doctype|html|head|body)[\s>]/i;

        // Log if the response looks like HTML
        if (htmlElementRegex.test(jsonString)) {
            // Add HTML snippet to the properties bag
            trackTrace('Received HTML instead of JSON', {
                properties: {
                    [Property.TruncatedProps]: jsonString.slice(0, 500),
                },
            });
        }

        throw clientError;
    }
};

/**
 * tryParseJson
 */

export const tryParseJson = <T>(jsonString: string): T | undefined => {
    try {
        return parseJson<T>(jsonString);
    } catch (err) {
        // do nothing
    }

    return undefined;
};
